/*
 * @Author: yzr
 * @Date: 2021-07-19 16:05:16
 * @Last Modified by: yzr
 * @Last Modified time: 2021-07-20 15:43:32
 */
import Form from './form.vue';

export default Form;
